import ForgotPassword from './container'

export default ForgotPassword
